export const valueToString = (str: string, style?: string) => {
  if (str === undefined || str === null) {
    return;
  }

  const result = str.replace(/_/g, " ");
  if (style === "uppercase") {
    return result.toUpperCase();
  } else {
    return result.replace(/(^\w|\s\w)/g, (c: string) => c.toUpperCase());
  }
};
